export type CheckboxProps = {
  label: string
  labelClassName?: string
  value: boolean
  setValue: (val: boolean) => void
  checkboxClassName?: string
}

export const Checkbox = ({ label, labelClassName, checkboxClassName, setValue, value, ...props }: CheckboxProps) => {
  const onClick = () => {
    setValue(!value)
  }

  return (
    <div className="flex flex-row items-center" onClick={onClick}>
      <input
        type="checkbox"
        {...props}
        className={`h-10 w-10 m-3 rounded-sm border-2 border-[#49454F] ${checkboxClassName ? checkboxClassName : ''}`}
        checked={value}
        readOnly
      />
      <p className={`cursor-pointer text-sm text-[#001762] ${labelClassName ? labelClassName : ''}`}>{label}</p>
    </div>
  )
}
